import React from 'react'
import TrimbleMap from 'transfix-maps/components/TrimbleMap'
import { IMapPosition, WithId } from 'transfix-maps/types'
import { IMapEnhancedStopProps } from 'apps/detention-review/types'
import { PositionCard } from './components/PositionCard'
import { StopCard } from './components/StopCard'

export interface IDetentionReviewMapComponentProps {
  positions: WithId<IMapPosition>[]
  stops: IMapEnhancedStopProps[]
  onViewChange: (enabled: boolean) => void
}

const DetentionReviewMapComponent = ({
  stops = [],
  positions: positionsProp = [],
  onViewChange,
}: IDetentionReviewMapComponentProps) => {
  /**
   * @note We reverse the order of these positions in <MapBase /> but this keeps it outside of the component
   */
  const positions = positionsProp.slice().reverse()
  return (
    <TrimbleMap
      dataTest='LastPingMap'
      maxZoom={5}
      enableView
      onViewChange={onViewChange}
      mapStyle='transportation'
      fitBoundsOptions={{
        padding: 48,
        animate: false,
      }}
      stops={stops}
      positions={positions.slice().reverse()}
      getPositionPopup={(properties, { mapFeatures = [], isLoading = false } = {}) => {
        return <PositionCard properties={properties} features={mapFeatures} isLoading={isLoading} />
      }}
      getStopPopup={properties => {
        return <StopCard properties={properties} />
      }}
      BoxProps={{
        height: 600,
      }}
    />
  )
}

export default DetentionReviewMapComponent
